const BASE_TITLE = 'Odium Manager';
const FAVICON_SRC = `${process.env.PUBLIC_URL || ''}/favicon-32.png`;

let baseFaviconHref = null;
let lastAppliedCount = null;
let applySeq = 0;

function ensureIconLink() {
  let link =
    document.querySelector("link[rel='icon'][type='image/png'][sizes='32x32']") ||
    document.querySelector("link[rel='icon'][type='image/png']") ||
    document.querySelector("link[rel='shortcut icon']") ||
    document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    document.head.appendChild(link);
  }
  if (!baseFaviconHref) {
    const href = link.getAttribute('href') || '';
    baseFaviconHref = href && !href.startsWith('data:') ? href : FAVICON_SRC;
  }
  return link;
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function drawBadgeFavicon(baseImg, count) {
  const size = 32;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  ctx.clearRect(0, 0, size, size);
  ctx.drawImage(baseImg, 0, 0, size, size);

  const label = count > 99 ? '99+' : String(Math.max(1, count));
  const fontSize = label.length >= 3 ? 10 : label.length === 2 ? 11 : 13;
  ctx.font = `bold ${fontSize}px system-ui, -apple-system, Segoe UI, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  const tw = ctx.measureText(label).width;
  const padX = 3;
  const h = 14;
  const w = Math.max(h, Math.ceil(tw + padX * 2));
  const x = size - w - 1;
  const y = size - h - 1;
  const r = h / 2;

  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
  ctx.fillStyle = '#dc2626';
  ctx.fill();
  ctx.strokeStyle = '#ffffff';
  ctx.lineWidth = 1.5;
  ctx.stroke();

  ctx.fillStyle = '#ffffff';
  ctx.fillText(label, x + w / 2, y + h / 2 + 0.5);

  return canvas.toDataURL('image/png');
}

/**
 * Browser-Tab: Titel + Favicon-Badge mit Ungelesen-Anzahl.
 * @param {number} unreadCount
 */
export async function applyTabUnreadBadge(unreadCount) {
  const n = Math.max(0, Number(unreadCount) || 0);
  const seq = ++applySeq;

  if (typeof document !== 'undefined') {
    document.title = n > 0 ? `(${n > 99 ? '99+' : n}) ${BASE_TITLE}` : BASE_TITLE;
  }

  if (typeof document === 'undefined') return;
  if (lastAppliedCount === n) return;

  try {
    const link = ensureIconLink();
    if (n <= 0) {
      if (seq !== applySeq) return;
      link.href = baseFaviconHref || FAVICON_SRC;
      link.type = 'image/png';
      lastAppliedCount = 0;
      return;
    }

    const img = await loadImage(baseFaviconHref || FAVICON_SRC);
    if (seq !== applySeq) return;

    const dataUrl = drawBadgeFavicon(img, n);
    if (!dataUrl) return;
    link.href = dataUrl;
    link.type = 'image/png';
    lastAppliedCount = n;
  } catch (_) {
    /* Favicon optional — Titel reicht als Fallback */
  }
}

export function resetTabUnreadBadge() {
  applySeq += 1;
  lastAppliedCount = null;
  if (typeof document !== 'undefined') {
    document.title = BASE_TITLE;
  }
  try {
    const link = ensureIconLink();
    if (baseFaviconHref) {
      link.href = baseFaviconHref;
      link.type = 'image/png';
    }
  } catch (_) {
    /* ignore */
  }
}
